// require('./global/announcements.js');
require('./global/sticky-header.js');
require('./global/language-switcher.js');
require('./global/menu.js');
require('./global/scroll-link.js');
require('./global/link.js');
require('./global/search.js');
require('./global/slider.js');
require('./global/gallery.js');
require('./components/accordion.js');
require('./components/image.js');
require('./components/logos.js');
// require('./components/modal.js');
require('./components/map.js');
require('./components/cookies-banner.js');
// require('./components/video.js');
// require('./global/third-party.js');


function reveal() {
    if(heroText) {
        var reveals = heroText;
        var elementTop = reveals.getBoundingClientRect().top;
        var y = window.scrollY;


        if (elementTop / 2 <= y / 2) {
            reveals.classList.add("active")
        } else {
            reveals.classList.remove("active");
        }

    }

}

window.addEventListener("scroll", reveal);
